import React, { useState, useContext, useEffect } from "react";
import { Button, CloseButton, Portal, Dialog, Field, Box, Textarea, FileUpload, Icon, Spinner, Slider } from "@chakra-ui/react";
import { LuUpload, LuText } from "react-icons/lu";
import { useAppStore } from "../../../../context/store";
import { floatingStyles, showToast } from "../../../../utilies/Utility";
import Type from "../../../../utilies/Types";

import { serviceAddLog } from "../../../../api/services/log";

const TaskManagementDailyReport = ({ state }) => {
  const userData = useAppStore((s) => s.userData);
  const currentTask = useAppStore((s) => s.currentTask);

  const [sendingData, setSendingData] = useState({
    report_text: "",
    project_id: null,
    task_id: null,
    progress_rate: 0,
    file: null,
  });

  const [isProgress, setIsProgress] = useState(false);

  useEffect(() => {
    if (state[0]) {
      setSendingData({
        report_text: "",
        project_id: currentTask?.project?.id,
        task_id: currentTask?.id,
        progress_rate: 0,
        file: null,
      });
    } else {
      setSendingData({
        report_text: "",
        project_id: null,
        task_id: null,
        progress_rate: 0,
        file: null,
      });
    }
  }, [state[0]]);

  const sendReportToServer = () => {
    const formData = new FormData();
    formData.append(
      "data",
      JSON.stringify({
        task_id: sendingData.task_id,
        context: sendingData.report_text,
        log_type: "report",
        progress: sendingData.progress_rate,
      }),
    );

    if (sendingData.file) {
      formData.append("file", sendingData.file);
    }
    setIsProgress(true);
    serviceAddLog(formData, userData.token)
      .then((res) => {
        setIsProgress(false);
        if (res.data.status === "success") {
          showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
        } else {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        }
      })
      .catch((err) => {
        console.error("Error", err);
        showToast(err.message, Type.NOTIFICATION.ERROR);
        setIsProgress(false);
      });
  };

  return (
    <Dialog.Root
      scrollBehavior="inside"
      placement={"top"}
      motionPreset="slide-in-right"
      closeOnInteractOutside={false}
      modal={false}
      open={state[0]}
      onOpenChange={(e) => {
        state[1](e.open);
      }}
    >
      <Portal>
        <Dialog.Positioner pointerEvents="none" height={"calc(100% - 30px)"}>
          <Dialog.Content mr={2} mb={0} mt={"70px"} height={"100%"} width={"400px"} maxWidth={"400px"} borderRadius={"2xl"}>
            <Dialog.Header>
              <Dialog.Title> Dialy Report </Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Field.Root mb={2}>
                <Box pos="relative" w="full">
                  <Textarea
                    className="peer"
                    rows={12}
                    value={sendingData.report_text}
                    onChange={(v) => {
                      setSendingData((prev) => ({
                        ...prev,
                        report_text: v.target.value,
                      }));
                    }}
                  />
                  <Field.Label css={floatingStyles}>
                    <LuText /> Description
                  </Field.Label>
                </Box>
              </Field.Root>
              <Slider.Root
                defaultValue={[sendingData.progress_rate]}
                mb={2}
                onChange={(v) => {
                  setSendingData((prev) => ({
                    ...prev,
                    progress_rate: parseInt(v.target.value),
                  }));
                }}
              >
                <Slider.Label>Progress Rate: {sendingData.progress_rate} %</Slider.Label>
                <Slider.Control>
                  <Slider.Track>
                    <Slider.Range />
                  </Slider.Track>
                  <Slider.Thumbs />
                </Slider.Control>
              </Slider.Root>
              <FileUpload.Root
                onFileChange={(u) => {
                  setSendingData((prev) => ({
                    ...prev,
                    file: parseInt(u.acceptedFiles[0]),
                  }));
                }}
                cursor={"pointer"}
                maxW="xl"
                alignItems="stretch"
                maxFiles={1}
                accept={[".geojson", ".osm", ".shp", ".sql", ".geotiff", ".png", ".jpeg", ".jpg"]}
              >
                <FileUpload.HiddenInput />
                <FileUpload.Dropzone>
                  <Icon size="md" color="fg.muted">
                    <LuUpload />
                  </Icon>
                  <FileUpload.DropzoneContent>
                    <Box>Drag and drop tutorial video here</Box>
                    <Box color="fg.muted">.geojson, .osm, .shp, .sql, .geojtiff, .png, .jpeg, .jpg</Box>
                  </FileUpload.DropzoneContent>
                </FileUpload.Dropzone>
                <FileUpload.List />
              </FileUpload.Root>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                variant="solid"
                colorPalette={"green"}
                disabled={isProgress}
                onClick={() => {
                  sendReportToServer();
                }}
              >
                {isProgress ? <Spinner size={"sm"} /> : "Send"}
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
export default TaskManagementDailyReport;
